document.addEventListener("DOMContentLoaded", e => {
  const variantBtn = document.querySelectorAll("[bss-b2b-variant-click]");
  variantBtn.forEach(btn => {
    btn.addEventListener("click", e => {
      setTimeout(() => {
        // window.dispatchEvent(new Event("scroll"))
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      }, 500)
    })
  })
})